import {Box, BoxProps, Container, Typography} from '@mui/material';
import {analytics} from '@resurs-internal/rb-app-api';
import {usePageView} from 'hooks';
import React, {FC} from 'react';
import {BackButton, BackButtonProps} from './BackButton';
import {BaseActionButton, BaseFullPageActions} from './BaseFullPageActions';

export interface BaseFullPageProps extends BoxProps {
  id: Lowercase<string>;
  title?: string;
  subtitle?: string;
  backButton?: BackButtonProps;
  actions?: BaseActionButton[];
  footer?: React.ReactNode;
}

export const BaseFullPage: FC<BaseFullPageProps> = ({
  id,
  title,
  subtitle,
  backButton,
  children,
  actions,
  footer,
  sx,
  ...rest
}) => {
  usePageView(id, title);

  return (
    <Box
      id={id}
      component={'main'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        inset: 0,
        backgroundColor: 'background.default',
        zIndex: 'modal',
        ...sx,
      }}
      {...rest}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          minHeight: {xs: '48px', md: '64px'},
          px: {xs: 2, md: 4},
        }}>
        <BackButton
          path={backButton?.path}
          title={backButton?.title}
          showCloseIcon={backButton?.showCloseIcon}
          navigateBackOnClick={!backButton?.path && !backButton?.onClick}
          onClick={() => {
            analytics.click({name: 'navigate_back', pageId: id});
            backButton?.onClick && backButton?.onClick();
          }}
        />
      </Box>
      <Container
        maxWidth={'sm'}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          position: 'relative',
          maxHeight: {xs: 'calc(100dvh - 48px)', md: 'calc(100dvh - 64px)'},
          padding: 0,
          pb: 4,
        }}>
        {Boolean(title) && (
          <Typography
            variant={'h6'}
            component={'h1'}
            textAlign={'center'}
            mb={2}>
            {title}
          </Typography>
        )}
        {Boolean(subtitle) && (
          <Typography variant={'body1'} textAlign={'center'}>
            {subtitle}
          </Typography>
        )}
        <Box sx={{flex: 1, p: 2, overflow: 'auto'}}>{children}</Box>
        {footer}
        <BaseFullPageActions actions={actions} />
      </Container>
    </Box>
  );
};
